$('.js-slider').each((index, slider) => {
  const $slider = $(slider);
  const data = $slider.data('slider') || {};

  $slider.slick(data);
});
